/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsHoopCategory,
    AssetsMelcoModelsHoopCategoryFromJSON,
    AssetsMelcoModelsHoopCategoryFromJSONTyped,
    AssetsMelcoModelsHoopCategoryToJSON,
    AssetsMelcoModelsHoopMachine,
    AssetsMelcoModelsHoopMachineFromJSON,
    AssetsMelcoModelsHoopMachineFromJSONTyped,
    AssetsMelcoModelsHoopMachineToJSON,
    AssetsMelcoModelsHoopPlatform,
    AssetsMelcoModelsHoopPlatformFromJSON,
    AssetsMelcoModelsHoopPlatformFromJSONTyped,
    AssetsMelcoModelsHoopPlatformToJSON,
    AssetsMelcoModelsHoopProduct,
    AssetsMelcoModelsHoopProductFromJSON,
    AssetsMelcoModelsHoopProductFromJSONTyped,
    AssetsMelcoModelsHoopProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsSyncHoop
 */
export interface AssetsMelcoModelsSyncHoop {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    cloud_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    english_dimensions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    metric_dimensions?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    skip_download?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    asset_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    preview_asset_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    discontinued?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    melco_pn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopCategory>}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    category_list?: Array<AssetsMelcoModelsHoopCategory> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopProduct>}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    product_list?: Array<AssetsMelcoModelsHoopProduct> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopMachine>}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    machine_list?: Array<AssetsMelcoModelsHoopMachine> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsHoopPlatform>}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    platform_list?: Array<AssetsMelcoModelsHoopPlatform> | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    asset?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    preview_asset?: string | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    signature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncHoop
     */
    asset_url?: string | null;
}

export function AssetsMelcoModelsSyncHoopFromJSON(json: any): AssetsMelcoModelsSyncHoop {
    return AssetsMelcoModelsSyncHoopFromJSONTyped(json, false);
}

export function AssetsMelcoModelsSyncHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsSyncHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cloud_id': !exists(json, 'cloud_id') ? undefined : json['cloud_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'english_dimensions': !exists(json, 'english_dimensions') ? undefined : json['english_dimensions'],
        'metric_dimensions': !exists(json, 'metric_dimensions') ? undefined : json['metric_dimensions'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'skip_download': !exists(json, 'skip_download') ? undefined : json['skip_download'],
        'asset_type': !exists(json, 'asset_type') ? undefined : json['asset_type'],
        'preview_asset_type': !exists(json, 'preview_asset_type') ? undefined : json['preview_asset_type'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'melco_pn': !exists(json, 'melco_pn') ? undefined : json['melco_pn'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(AssetsMelcoModelsHoopCategoryFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(AssetsMelcoModelsHoopProductFromJSON)),
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(AssetsMelcoModelsHoopMachineFromJSON)),
        'platform_list': !exists(json, 'platform_list') ? undefined : (json['platform_list'] === null ? null : (json['platform_list'] as Array<any>).map(AssetsMelcoModelsHoopPlatformFromJSON)),
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'preview_asset': !exists(json, 'preview_asset') ? undefined : json['preview_asset'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'asset_url': !exists(json, 'asset_url') ? undefined : json['asset_url'],
    };
}

export function AssetsMelcoModelsSyncHoopToJSON(value?: AssetsMelcoModelsSyncHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cloud_id': value.cloud_id,
        'id': value.id,
        'name': value.name,
        'english_dimensions': value.english_dimensions,
        'metric_dimensions': value.metric_dimensions,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'skip_download': value.skip_download,
        'asset_type': value.asset_type,
        'preview_asset_type': value.preview_asset_type,
        'type': value.type,
        'discontinued': value.discontinued,
        'melco_pn': value.melco_pn,
        'publish_state': value.publish_state,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(AssetsMelcoModelsHoopCategoryToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(AssetsMelcoModelsHoopProductToJSON)),
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(AssetsMelcoModelsHoopMachineToJSON)),
        'platform_list': value.platform_list === undefined ? undefined : (value.platform_list === null ? null : (value.platform_list as Array<any>).map(AssetsMelcoModelsHoopPlatformToJSON)),
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'asset': value.asset,
        'preview_asset': value.preview_asset,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'signature': value.signature,
        'asset_url': value.asset_url,
    };
}


